import React, { useEffect, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { Button, Table, Pagination, Row, Col, Space } from 'antd'
import { CheckCircleOutlined, CloseCircleOutlined, DeleteOutlined, FormOutlined } from '@ant-design/icons'
import { Loading, Page, Panel, Total } from '../../../../../components'
import { BreadcrumbSystem as Breadcrumb, SysPermission } from '../../../../../constants'
import { sysAdminRoleService } from '../../../../../services'
import { auth, validator } from '../../../../../util'
import { SysStore } from '../../../../../stores'

import 'antd/dist/antd.css'
import './styles.css'

const pageSize = 20

/** Rule: Must define breadcrumb in every page **/
const breadcrumb = [
  Breadcrumb.HomeBase,
  Breadcrumb.SystemBase,
  Breadcrumb.SystemAdminRoleList
]

const columns = [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    width: 8
  },
  {
    title: 'Description',
    dataIndex: 'description',
    key: 'description',
    width: 11
  },
  {
    width: 2,
    title: 'Active',
    dataIndex: 'active',
    key: 'active',
    render: (active) => active === true
      ? <CheckCircleOutlined style={{color: '#4fbc85', fontSize: '14pt'}} />
      : <CloseCircleOutlined style={{color: '#ccc', fontSize: '14pt'}} />
  },
  {
    width: 3,
    render: (item) => <Space size='middle'>
      { hasAccess(SysPermission.PORTAL.SYS_ROLES.READ)
        ? <Link to={`/systems/roles/${item.id}`} key={`rolekey${item.id}`}>
          <FormOutlined />
        </Link>
        : null }
    </Space>
  },
]

const hasAccess = (permission) => {
  return auth.hasAccess(permission)
}

function SystemUserRoleList () {
  const [isLoading, setIsLoading] = useState(false)
  const [filter, setFilter] = useState({ active: true })
  const [sort, setSort] = useState({})

  useEffect(() => {
    fetchList({ currentPage: 1 })
  }, [])

  const list = SysStore.useState(e => e.sysUserRoleList)
  const page = SysStore.useState(e => e.sysModulePage)
  const total = SysStore.useState(e => e.sysUserRoleTotal)
  const isSysUserRoleListLoading = SysStore.useState(e => e.isSysUserRoleListLoading)

  async function fetchList ({ currentPage = page }) {
    if (!hasAccess(SysPermission.PORTAL.SYS_ROLES.LIST)) return

    setIsLoading(true)
    const r = await sysAdminRoleService.listByPage(currentPage, pageSize, filter, sort)
    if (r && r.list) {
      setIsLoading(false)
      SysStore.update(e => {
        e.sysUserRoleList = r.list
        e.sysUserRoleTotal = r.total
        e.sysModulePage = currentPage
      })
    }
  }

  return (
    <Page.Body>
      <Page.Breadcrumb item={breadcrumb} />

      <Page.Header title='User Roles'>
        { hasAccess(SysPermission.PORTAL.SYS_ROLES.CREATE)
          ? <Link to='/systems/roles/add'>
            <Button shape='round' type='primary'>Add User Role</Button>
          </Link>
          : null }

      </Page.Header>

      <Page.Content>
        <Table
          loading={isLoading}
          columns={columns}
          dataSource={list}
          size='small'
          rowKey={(itm) => (`rolels${itm.id}`)}
          pagination={{
            hideOnSinglePage: true,
            pageSize,
            total,
            onChange: (e) => fetchList({currentPage: e})
          }}
        />
        <Total total={total} title={'role'} />
      </Page.Content>
    </Page.Body>
  )
}

export default SystemUserRoleList
